module.exports = __webpack_public_path__ + "img/81d93f8.jpg";